import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/highlights_200.png'


const _withScopeId = n => (_pushScopeId("data-v-28f9e192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "highlights-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("h1", null, " Highlights ")
], -1))
const _hoisted_3 = { class: "page-content" }

import HighlightsList from './HighlightsList.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HighlightsPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(HighlightsList)
    ])
  ]))
}
}

})